import arrow from "../../../assests/Images/TemplateElement/Arrow.svg";
import blueStar from "../../../assests/Images/TemplateElement/blueStar.png";
import JoyLogo from "../../../assests/Images/TemplateElement/JoyBlueLogo.png";
import pinkStar from "../../../assests/Images/TemplateElement/transparentPinkStar.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

export default function TextTemplateWhite({ heading, caption, date, journalId,pageRefresh,ref,menuShow }) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading || ""}
      bodyText={caption || ""}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#ffffff"
      headingColor="#007aff"
      textColor="#000000"
      borderColor="#ff0080"
      imageTopLeft={arrow}
      imageTopLeftStyle={{
        width: { xs: 40, sm: 70, md: 70 },
        height: { xs: 40, sm: 70, md: 70 },
        top: 10,
        left: 10,
      }}
      imageTopRight={pinkStar}
      imageTopRightStyle={{
        width: { xs: 100, sm: 150, md: 150 },
        height: { xs: 100, sm: 150, md: 150 },
        top: -30,
        right: -30,
        opacity: 0.4,
      }}
      imageBottomLeft={blueStar}
      imageBottomLeftStyle={{
        width: { xs: 200, sm: 250, md: 250 },
        height: { xs: 200, sm: 250, md: 250 },
        bottom: 20,
        left: -75,
        opacity: 0.1,
      }}
      imageBottomRight={JoyLogo}
      imageBottomRightStyle={{
        width: { xs: 16, sm: 24, md: 24 },
        height: { xs: 16, sm: 24, md: 24 },
        bottom: { xs: 5, sm: 5, md: 5 },
        right: { xs: 5, sm: 5, md: 5 },
      }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}
